import { useContext, useState } from 'react';
import { GuildContext } from '../../../utils/contexts/GuildContext';
import { useFetchLang } from '../../../utils/hooks/useFetchLang';
import { Spinner } from '../../../components/misc/Spinner'
import { useNavigate } from "react-router-dom";
import { MoonLoader } from 'react-spinners';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'
import styles from './index.module.scss'
import { PostLang } from '../../../utils/post/postLang';
import { useFetchClientLang } from '../../../utils/hooks/useFetchClientLang';
import { Notification } from '../../../components/misc/Notification';

const MenuPage = () => {
  const [postLoading, setPostLoading] = useState(false)
  const [postDone, setPostDone] = useState(false)

  const { guild } = useContext(GuildContext);
  const { lang, loading } = useFetchLang(guild?.id);
  const { clientLang } = useFetchClientLang()

  const navigate = useNavigate()

  if (loading) return <Spinner children={<MoonLoader size={40} color="white" />} />

  // console.log(lang?.language)
  // console.log(clientLang?.language)

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setPostLoading(true)

    console.log(e.target.language.value)

    PostLang(guild?.id, e.target.language.value).then(async () => {
      await setPostDone(true)
      await setPostLoading(false)
      await setTimeout(() => setPostDone(false), 5000);
    })
    
  };
  
  return (
    <div>
      <div className="page">
        <div className={styles.container}>
          <div className={styles.flex}>
            <h1>Change bot language:</h1>
            <div onClick={() => navigate('/dashboard/categories')}>
              <BsFillArrowLeftCircleFill size={35} color="#ffffff"/>
            </div>
          </div>

          <form className={styles.form} onSubmit={handleSubmit}>
            <select name="language">
              {
                clientLang?.language.map(v => (
                  <option key={v} value={v} selected={v === lang?.language ? true : false}>{v}</option>
                ))
              }
            </select>
            
            <br/>
            <div className={styles.inputflex}>
              <button className={styles.summit} type="submit">Update</button>
              <button className={styles.summit} type="submit" >Cancel</button>
              <div>
                { postLoading ? <MoonLoader size={35} color="white" /> : <></> }
              </div>
            </div>
          </form>
        </div>
      </div>

      <div>
        { 
          postDone ? 
            <Notification 
              title="Done!" 
              description="Your server language has been successfully updated!"
            /> 
          : <></> 
        }
      </div>
    </div>
  )
}

export default MenuPage